import Slider from 'rc-slider';
import type { SliderProps } from 'rc-slider';
import 'rc-slider/assets/index.css';

const RangeSlider = (props: SliderProps<number[]>) => {
  return (
    <Slider
      {...props}
      range
      styles={{
        rail: {
          background: '#C7C7C7',
        },
        track: {
          background: '#ce181e',
        },
      }}
      activeDotStyle={{ background: 'black' }}
      handleRender={({ props }) => {
        return (
          <div
            {...props}
            style={{
              left: props.style.left,
              transform: props.style.transform,
              width: '24px',
              height: '24px',
              border: '1px solid #ce181e',
              borderRadius: '50%',
              outline: 'none',
              boxShadow: 'none',
              top: 0,
              background: 'white',
              opacity: 1,
              marginTop: '-5px',
            }}
          />
        );
      }}
    />
  );
};

export default RangeSlider;
